import { render, staticRenderFns } from "./PointWithdraw.vue?vue&type=template&id=fd705508&scoped=true"
import script from "./PointWithdraw.vue?vue&type=script&lang=js"
export * from "./PointWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd705508",
  null
  
)

export default component.exports